module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/note_icon-55c87d9b9bad37bf6e1e1f978bec52fb.png";